import type { LineBand } from '../model/types'

/** Размер слова с фото в rem по полосе веса: крупное на снимке чуть крупнее, мелкое чуть мельче (не только цветом); отброшенное — как мелкое. */
export const WORD_FONT_REM: Readonly<Record<LineBand, number>> = { key: 0.95, medium: 0.85, minor: 0.75, ignored: 0.75 }
